export enum ADMIN_ROLE {
  'ADMIN_FINANCE' = 'ADMIN_FINANCE',
  'ADMIN_LOGISTICS' = 'ADMIN_LOGISTICS',
  'ADMIN_NORMAL' = 'ADMIN_NORMAL',
  'ADMIN_OPERATION' = 'ADMIN_OPERATION',
  'ADMIN_SUPER' = 'ADMIN_SUPER',
}
export const CONST_ADMIN_ROLE = Object.values(ADMIN_ROLE);

export enum ADMIN_STATUS {
  'APPROVAL' = 'APPROVAL',
  'DELETED' = 'DELETED',
  'DENIED' = 'DENIED',
  'REFUSED' = 'REFUSED',
  'REREQUEST' = 'REREQUEST',
  'WAITING' = 'WAITING',
}
export const CONST_ADMIN_STATUS = Object.values(ADMIN_STATUS);

export enum APPROVED_STATUS {
  'APPROVAL' = 'APPROVAL',
  'DELETED' = 'DELETED',
  'REFUSED' = 'REFUSED',
  'WAITING' = 'WAITING',
}
export const CONST_APPROVED_STATUS = Object.values(APPROVED_STATUS);

export enum B2LINK_DEPT {
  'B2LABS' = 'B2LABS',
  'CBT' = 'CBT',
  'GS' = 'GS',
  'OTHERS' = 'OTHERS',
  'UO' = 'UO',
  'USP' = 'USP',
}
export const CONST_B2LINK_DEPT = Object.values(B2LINK_DEPT);

export enum BADGE_TYPE {
  'BEST' = 'BEST',
  'CLEARANCE' = 'CLEARANCE',
  'CPNP' = 'CPNP', // 노출
  'CRUELTY' = 'CRUELTY', // 노출
  'NEW' = 'NEW',
  'PERCENT' = 'PERCENT',
  'PROMOTION' = 'PROMOTION',
  'ROCKET' = 'ROCKET', // 노출
  'SALE' = 'SALE',
  'SCPNP' = 'SCPNP', // 노출
  'UMMA_PICK' = 'UMMA_PICK',
  'UDIRECT' = 'UDIRECT', // 노출
  'VEGAN' = 'VEGAN', // 노출
}
export const CONST_BADGE_TYPE = Object.values(BADGE_TYPE);

export enum BANNER_TYPE {
  'BOTTOM' = 'BOTTOM',
  'BRAND' = 'BRAND',
  'MIDDLE1' = 'MIDDLE1',
  'MIDDLE2' = 'MIDDLE2',
  'PROMOTIONS' = 'PROMOTIONS',
  'SIGNUP' = 'SIGNUP',
  'TOP' = 'TOP',
  'UMMA_BEAUTY' = 'UMMA_BEAUTY',
  'VISUAL' = 'VISUAL',
  'POPUP' = 'POPUP',
}
export const CONST_BANNER_TYPE = Object.values(BANNER_TYPE);

export enum BIZ_TYPE_RETAIL {
  'OFFLINE_BEAUTY_SALON' = 'OFFLINE_BEAUTY_SALON',
  'OFFLINE_COSMETICS_STORE' = 'OFFLINE_COSMETICS_STORE',
  'OFFLINE_MOM_&_POP' = 'OFFLINE_MOM_&_POP',
  'OFFLINE_SUPERMARKET' = 'OFFLINE_SUPERMARKET',
  'ONLINE_INFLUENCER' = 'ONLINE_INFLUENCER',
  'ONLINE_OPEN_MARKET' = 'ONLINE_OPEN_MARKET',
  'ONLINE_SOHO_MALL' = 'ONLINE_SOHO_MALL',
}
export const CONST_BIZ_TYPE_RETAIL = Object.values(BIZ_TYPE_RETAIL);

export enum BIZ_TYPE_WHOLE {
  'OFFLINE_BEAUTY_SALON' = 'OFFLINE_BEAUTY_SALON',
  'OFFLINE_COSMETICS_STORE' = 'OFFLINE_COSMETICS_STORE',
  'OFFLINE_MOM_&_POP' = 'OFFLINE_MOM_&_POP',
  'OFFLINE_SUPERMARKET' = 'OFFLINE_SUPERMARKET',
  'ONLINE_INFLUENCER' = 'ONLINE_INFLUENCER',
  'ONLINE_OPEN_MARKET' = 'ONLINE_OPEN_MARKET',
  'ONLINE_SOHO_MALL' = 'ONLINE_SOHO_MALL',
}
export const CONST_BIZ_TYPE_WHOLE = Object.values(BIZ_TYPE_WHOLE);

export enum BIZ_VOLUME {
  'LEVEL0' = 'LEVEL0',
  'LEVEL1' = 'LEVEL1',
  'LEVEL2' = 'LEVEL2',
  'LEVEL3' = 'LEVEL3',
  'LEVEL4' = 'LEVEL4',
  'LEVEL5' = 'LEVEL5',
  'LEVEL6' = 'LEVEL6',
  'LEVEL7' = 'LEVEL7',
  'LEVEL8' = 'LEVEL8',
  'LEVEL9' = 'LEVEL9',
}
export const CONST_BIZ_VOLUME = Object.values(BIZ_VOLUME);

export enum BRAND_STATUS {
  'APPROVAL' = 'APPROVAL',
  'DELETED' = 'DELETED',
  'WAITING' = 'WAITING',
}
export const CONST_BRAND_STATUS = Object.values(BRAND_STATUS);

export enum BUSINESS_TYPE {
  'BOTH' = 'BOTH',
  'RETAILER' = 'RETAILER',
  'WHOLESALE' = 'WHOLESALE',
}
export const CONST_BUSINESS_TYPE = Object.values(BUSINESS_TYPE);

export enum QUESTION_SUBTYPE {
  'ADVERTISEMENT' = 'ADVERTISEMENT',
  'BLOG' = 'BLOG',
  'OTHER' = 'OTHER',
  'RECOMMENDED_BY_FRIEND' = 'RECOMMENDED_BY_FRIEND',
  'SALES_CONTACT' = 'SALES_CONTACT',
  'SEARCH_BING' = 'SEARCH_BING',
  'SEARCH_ENGINE' = 'SEARCH_ENGINE',
  'SEARCH_GOOGLE' = 'SEARCH_GOOGLE',
  'SOCIAL_FACEBOOK' = 'SOCIAL_FACEBOOK',
  'SOCIAL_INSTAGRAM' = 'SOCIAL_INSTAGRAM',
  'SOCIAL_MEDIA' = 'SOCIAL_MEDIA',
  'SOCIAL_TIKTOK' = 'SOCIAL_TIKTOK',
}
export const CONST_QUESTION_SUBTYPE = Object.values(QUESTION_SUBTYPE);

export enum QUESTION_TYPE {
  'HOW_DID_YOU_HEAR_ABOUT_US' = 'HOW_DID_YOU_HEAR_ABOUT_US',
}
export const CONST_QUESTION_TYPE = Object.values(QUESTION_TYPE);

export enum BUYER_COMPANY_STATUS {
  'APPROVAL' = 'APPROVAL',
  'CANCEL_REQUEST' = 'CANCEL_REQUEST',
  'EXPIRED' = 'EXPIRED',
  'OUT' = 'OUT',
  'REFUSE_REQUEST' = 'REFUSE_REQUEST',
  'REFUSE_SIGNUP' = 'REFUSE_SIGNUP',
  'REREQUEST' = 'REREQUEST',
  'UPDATE_REQUEST' = 'UPDATE_REQUEST',
  'WAITING' = 'WAITING',
}
export const CONST_BUYER_COMPANY_STATUS = Object.values(BUYER_COMPANY_STATUS);

export enum BUYER_ROLE {
  'BUYER_APPROVED' = 'BUYER_APPROVED',
  'BUYER_NOT_APPROVED' = 'BUYER_NOT_APPROVED',
}
export const CONST_BUYER_ROLE = Object.values(BUYER_ROLE);

export enum BUYER_STATUS {
  'APPROVAL' = 'APPROVAL',
  'DELETED' = 'DELETED',
  'DENIED' = 'DENIED',
  'DORMANT' = 'DORMANT',
  'REFUSED' = 'REFUSED',
  'REREQUEST' = 'REREQUEST',
  'WAITING' = 'WAITING',
}
export const CONST_BUYER_STATUS = Object.values(BUYER_STATUS);

export enum CAPACITY_UNIT_TYPE {
  'G' = 'G',
  'GML' = 'GML',
  'ML' = 'ML',
}
export const CONST_CAPACITY_UNIT_TYPE = Object.values(CAPACITY_UNIT_TYPE);

export enum CERTIFICATION_TYPE {
  'AUSTRALIAN_CERTIFIED_ORGANIC' = 'AUSTRALIAN_CERTIFIED_ORGANIC',
  'BANNED_SUBSTANCES_CONTROL_GROUP_BSCG' = 'BANNED_SUBSTANCES_CONTROL_GROUP_BSCG',
  'BFC' = 'BFC',
  'BPA_FREE' = 'BPA_FREE',
  'CCIC_CRUELTY_FREE' = 'CCIC_CRUELTY_FREE',
  'CCOF_ORGANIC' = 'CCOF_ORGANIC',
  'CERTIFIED_ORGANIC' = 'CERTIFIED_ORGANIC',
  'CHOOSE_CRUELTY_FREE' = 'CHOOSE_CRUELTY_FREE',
  'CODEX_GMP' = 'CODEX_GMP',
  'COSMOS_STANDARD' = 'COSMOS_STANDARD',
  'CRUELTY_FREE' = 'CRUELTY_FREE',
  'DESIGNLIGHTS_CONSORTIUM_DLC_CERTIFICATION' = 'DESIGNLIGHTS_CONSORTIUM_DLC_CERTIFICATION',
  'ECOCERT' = 'ECOCERT',
  'EWG_VERIFIED' = 'EWG_VERIFIED',
  'FAIR_TRADE_CERTIFIED' = 'FAIR_TRADE_CERTIFIED',
  'FDA_ANTIBIOTIC_FREE' = 'FDA_ANTIBIOTIC_FREE',
  'GENERALLY_RECOGNIZED_AS_SAFE_GRAS' = 'GENERALLY_RECOGNIZED_AS_SAFE_GRAS',
  'GLOBAL_CERTIFICATION_SERVICE_LTD' = 'GLOBAL_CERTIFICATION_SERVICE_LTD',
  'GLUTEN_REDUCED_CERTIFIED' = 'GLUTEN_REDUCED_CERTIFIED',
  'HALAL_CERTIFICATION' = 'HALAL_CERTIFICATION',
  'HEALTH_CANADA' = 'HEALTH_CANADA',
  'ISO_22716_2007' = 'ISO_22716_2007',
  'LEAPING_BUNNY_APPROVED' = 'LEAPING_BUNNY_APPROVED',
  'MADE_SAFE' = 'MADE_SAFE',
  'NON_GMO_TESTED' = 'NON_GMO_TESTED',
  'NPA_NATURAL_SEAL_PERSONAL_CARE' = 'NPA_NATURAL_SEAL_PERSONAL_CARE',
  'NSF_ANSI_305' = 'NSF_ANSI_305',
  'NSF_GMP' = 'NSF_GMP',
  'NSF_NON_GMO' = 'NSF_NON_GMO',
  'PALEO_CERTIFIED' = 'PALEO_CERTIFIED',
  'PDO_PROTECTED_DESIGNATION_OF_ORIGIN' = 'PDO_PROTECTED_DESIGNATION_OF_ORIGIN',
  'PEFC' = 'PEFC',
  'PETA_CRUELTY_FREE' = 'PETA_CRUELTY_FREE',
  'PETA_CRUELTY_FREE_AND_VEGAN' = 'PETA_CRUELTY_FREE_AND_VEGAN',
  'PFOA_FREE' = 'PFOA_FREE',
  'SEDEX_CERTIFIED' = 'SEDEX_CERTIFIED',
  'SGS_PRODUCT_CERTIFIED' = 'SGS_PRODUCT_CERTIFIED',
  'THE_GREEN_GOOD_HOUSEKEEPING_SEAL' = 'THE_GREEN_GOOD_HOUSEKEEPING_SEAL',
  'UL_CERTIFICATION' = 'UL_CERTIFICATION',
  'US_HALAL_CERTIFICATION' = 'US_HALAL_CERTIFICATION',
  'USDA_BIOPREFERRED' = 'USDA_BIOPREFERRED',
  'USDA_CERTIFIED_BIOBASED_PRODUCT' = 'USDA_CERTIFIED_BIOBASED_PRODUCT',
  'USDA_ORGANIC' = 'USDA_ORGANIC',
  'VEGAN_CERTIFIED' = 'VEGAN_CERTIFIED',
}
export const CONST_CERTIFICATION_TYPE = Object.values(CERTIFICATION_TYPE);

export enum CERTIFICATE_STATUS { // 유다이렉트 서류 상태값
  'APPROVED' = 'APPROVED',       // 승인
  'COMPLETED' = 'COMPLETED',     // 완료
  'INVALID' = 'INVALID',         // 무효
  'PENDING' = 'PENDING',         // 대기
  'REJECTED' = 'REJECTED',       // 반려
}
export const CONST_CERTIFICATE_STATUS = Object.values(CERTIFICATE_STATUS);

export enum EXCHANGE_TYPE {
  'BUY' = 'BUY',
  'SELL' = 'SELL',
}
export const CONST_EXCHANGE_TYPE = Object.values(EXCHANGE_TYPE);

export enum INCOTERMS {
  'DAP' = 'DAP',
  'EXW' = 'EXW',
  'FCA' = 'FCA',
}
export const CONST_INCOTERMS = Object.values(INCOTERMS);

export enum SHIPPING_SERVICE_CODE {
  'UPS' = 'UPS',
  'EU-UPS' = 'EU-UPS', // 유다이렉트 전용
  'EMS' = 'EMS',
  'EU-EMS' = 'EU-EMS', // 유다이렉트 전용
  'DHL' = 'DHL',
  'EU-DHL' = 'EU-DHL', // 유다이렉트 전용
  'LBC' = 'LBC',
  'EXW' = 'EXW',
  'EU-EXW' = 'EU-EXW', // 유다이렉트 전용
  'FCA' = 'FCA',
  'RIN' = 'RIN',
  'EFS' = 'EFS',
  'GOL' = 'GOL',
  'NIGERIA' = 'NIGERIA',
  'TAIWAN' = 'TAIWAN',
  'ARAMEX' = 'ARAMEX',
  'FEDEX' = 'FEDEX',
}
export const CONST_SHIPPING_SERVICE_CODE = Object.values(SHIPPING_SERVICE_CODE);

export enum INQUIRY_TYPE {
  'ORDER' = 'ORDER',
  'OTHERS' = 'OTHERS',
  'PARTNERSHIP' = 'PARTNERSHIP',
  'PAYMENT' = 'PAYMENT',
  'PRODUCT' = 'PRODUCT',
  'REFUND' = 'REFUND',
  'SHIPPING' = 'SHIPPING',
  'SIGNUP' = 'SIGNUP',
  'SYSTEM' = 'SYSTEM',
}
export const CONST_INQUIRY_TYPE = Object.values(INQUIRY_TYPE);

export enum INQUIRY_REPLY_STATUS {
  'REPLIED' = 'REPLIED',
  'WAITING' = 'WAITING',
}
export const CONST_INQUIRY_REPLY_STATUS = Object.values(INQUIRY_REPLY_STATUS);

export enum K_BIZ_SCALE {
  'LEVEL0' = 'LEVEL0',
  'LEVEL1' = 'LEVEL1',
  'LEVEL2' = 'LEVEL2',
  'LEVEL3' = 'LEVEL3',
  'LEVEL4' = 'LEVEL4',
  'LEVEL5' = 'LEVEL5',
  'LEVEL6' = 'LEVEL6',
  'LEVEL7' = 'LEVEL7',
  'LEVEL8' = 'LEVEL8',
}
export const CONST_K_BIZ_SCALE = Object.values(K_BIZ_SCALE);

export enum MSDS_POSSESSION_STATUS {
  'IN_POSSESSION' = 'IN_POSSESSION',
  'NOT_IN_POSSESSION' = 'NOT_IN_POSSESSION',
}
export const CONST_MSDS_POSSESSION_STATUS = Object.values(MSDS_POSSESSION_STATUS);

export enum NOTICE_CATEGORY {
  'APP' = 'APP',
  'EVENT' = 'EVENT',
  'NEWS' = 'NEWS',
  'NOTICE' = 'NOTICE',
  'OTHERS' = 'OTHERS',
  'PRIVACY_POLICY' = 'PRIVACY_POLICY',
  'SERVICE' = 'SERVICE',
  'SYSTEM' = 'SYSTEM',
  'TERMS_POLICY' = 'TERMS_POLICY',
}
export const CONST_NOTICE_CATEGORY = Object.values(NOTICE_CATEGORY);

export enum NOTICE_TYPE {
  'ADMIN' = 'ADMIN',
  'BUYER' = 'BUYER',
}
export const CONST_NOTICE_TYPE = Object.values(NOTICE_TYPE);

export enum FAQ_CATEGORY {
  'TOP10' = 'TOP10',
  'SHIPPING' = 'SHIPPING',
  'ORDER' = 'ORDER',
  'REFUND' = 'REFUND',
  'ACCOUNT' = 'ACCOUNT',
  'OTHERS' = 'OTHERS',
}
export const CONST_FAQ_CATEGORY = Object.values(FAQ_CATEGORY);

export enum FAQ_TYPE {
  'ACCOUNT' = 'ACCOUNT',
  'ORDER' = 'ORDER',
  'OTHERS' = 'OTHERS',
  'REFUND' = 'REFUND',
  'SHIPPING' = 'SHIPPING',
  'TOP10' = 'TOP10',
}
export const CONST_FAQ_TYPE = Object.values(FAQ_TYPE);

export enum SHIPPING_STATUS {
  'CANCELED' = 'CANCELED',
  'COMPLETED' = 'COMPLETED',
  'WAITING' = 'WAITING',
}
export const CONST_SHIPPING_STATUS = Object.values(SHIPPING_STATUS);

export enum PRODUCT_SHIPPING_TYPE {
  'GENERAL' = 'GENERAL',
  'ROCKET' = 'ROCKET',
  'STOCK' = 'STOCK',
  'UDIRECT' = 'UDIRECT',
}
export const CONST_PRODUCT_SHIPPING_TYPE = Object.values(PRODUCT_SHIPPING_TYPE);

export enum SHIPPING_TYPE {
  'GENERAL' = 'GENERAL',
  'ROCKET' = 'ROCKET',
  'UDIRECT' = 'UDIRECT',
}
export const CONST_SHIPPING_TYPE = Object.values(SHIPPING_TYPE);

export enum SLOT_TYPE {
  'BOTTOM' = 'BOTTOM',
  'TOP' = 'TOP',
}
export const CONST_SLOT_TYPE = Object.values(SLOT_TYPE);

export enum PAYMENT_METHOD {
  // DO NOT CHANGE ORDER
  'TT' = 'TT',
  'PAYPAL' = 'PAYPAL',
  'PAYONEER' = 'PAYONEER',
  // 'EXIMBAY' = 'CREDIT/DEBIT',
}
export const CONST_PAYMENT_METHOD = Object.values(PAYMENT_METHOD);

export enum PAYMENT_STATUS {
  'CANCELLED' = 'CANCELLED',
  'PAID' = 'PAID',
  'PENDING' = 'PENDING',
  'REFUND_WAITING' = 'REFUND_WAITING',
  'REFUNDED' = 'REFUNDED',
}
export const CONST_PAYMENT_STATUS = Object.values(PAYMENT_STATUS);

export enum PAYMENT_TYPE {
  'PARTIAL_REFUND' = 'PARTIAL_REFUND',
  'PAY' = 'PAY',
  'REFUND' = 'REFUND',
  'SHIPPING_REFUND' = 'SHIPPING_REFUND',
}
export const CONST_PAYMENT_TYPE = Object.values(PAYMENT_TYPE);

export enum PAYPAL_STATUS {
  'APPROVED' = 'APPROVED',
  'CANCELLED' = 'CANCELLED',
  'CAPTURED' = 'CAPTURED',
  'COMPLETED' = 'COMPLETED',
  'CREATED' = 'CREATED',
  'DECLINED' = 'DECLINED',
  'DENIED' = 'DENIED',
  'EXPIRED' = 'EXPIRED',
  'PARTIALLY_CAPTURED' = 'PARTIALLY_CAPTURED',
  'PARTIALLY_REFUNDED' = 'PARTIALLY_REFUNDED',
  'PENDING' = 'PENDING',
  'REFUNDED' = 'REFUNDED',
  'SAVED' = 'SAVED',
  'VOIDED' = 'VOIDED',
}
export const CONST_PAYPAL_STATUS = Object.values(PAYPAL_STATUS);

export enum EXIMBAY_OSTYPE {
  PC = 'P', // pc version(기본값)
  MOBILE = 'M', // mobile
}

export enum POINT_TYPE {
  'ADMIN' = 'ADMIN',
  'FIRST' = 'FIRST',
  'MILEAGE' = 'MILEAGE',
  'SIGNUP' = 'SIGNUP',
}
export const CONST_POINT_TYPE = Object.values(POINT_TYPE);

export enum POINT_UNIT_TYPE {
  'FIXED' = 'FIXED',
  'PERCENT' = 'PERCENT',
}
export const CONST_POINT_UNIT_TYPE = Object.values(POINT_UNIT_TYPE);

export enum PRODUCT_OPTION_TYPE {
  'COMPOSITE' = 'COMPOSITE',
  'SINGLE' = 'SINGLE',
}
export const CONST_PRODUCT_OPTION_TYPE = Object.values(PRODUCT_OPTION_TYPE);

export enum PRODUCT_STATUS {
  'APPROVAL' = 'APPROVAL',
  'DELETED' = 'DELETED',
  'OUT_OF_STOCK' = 'OUT_OF_STOCK',
  'REFUSED' = 'REFUSED',
  'WAITING' = 'WAITING',
}
export const CONST_PRODUCT_STATUS = Object.values(PRODUCT_STATUS);

export enum PRODUCT_TYPE {
  'OPTION' = 'OPTION',
  'SINGLE' = 'SINGLE',
}
export const CONST_PRODUCT_TYPE = Object.values(PRODUCT_TYPE);

export enum PROMOTION_TYPE {
  'EXCLUSIVE' = 'EXCLUSIVE',
  'POINT' = 'POINT',
  'PROMOTION' = 'PROMOTION',
}
export const CONST_PROMOTION_TYPE = Object.values(PROMOTION_TYPE);

export enum PURCHASE_ORDER_ADMIN_STATUS {
  'CALLBACK' = 'CALLBACK',
  'CANCELLED' = 'CANCELLED',
  'COMPLETED' = 'COMPLETED',
  'DELIVERED' = 'DELIVERED',
  'EXCHANGE_WAITING' = 'EXCHANGE_WAITING',
  'EXCHANGED' = 'EXCHANGED',
  'PENDING' = 'PENDING',
  'PREPARING' = 'PREPARING',
  'READY' = 'READY',
  'REFUND_BUYER_REQUEST' = 'REFUND_BUYER_REQUEST',
  'REFUND_CANCELLED' = 'REFUND_CANCELLED',
  'REFUND_REQUEST' = 'REFUND_REQUEST',
  'REFUND_WAITING' = 'REFUND_WAITING',
  'REFUNDED' = 'REFUNDED',
  'RETURN_WAITING' = 'RETURN_WAITING',
  'RETURNED' = 'RETURNED',
  'SHIPMENT_WAITING' = 'SHIPMENT_WAITING',
  'SHIPPING' = 'SHIPPING',
  'SOURCING' = 'SOURCING',
}
export const CONST_PURCHASE_ORDER_ADMIN_STATUS = Object.values(PURCHASE_ORDER_ADMIN_STATUS);

export enum PURCHASE_ORDER_BUYER_STATUS {
  'CANCELLED' = 'CANCELLED',
  'COMPLETED' = 'COMPLETED',
  'DELIVERED' = 'DELIVERED',
  'EXCHANGE_WAITING' = 'EXCHANGE_WAITING',
  'EXCHANGED' = 'EXCHANGED',
  'PENDING' = 'PENDING',
  'PREPARING' = 'PREPARING',
  'REFUND_WAITING' = 'REFUND_WAITING',
  'REFUNDED' = 'REFUNDED',
  'RETURN_WAITING' = 'RETURN_WAITING',
  'RETURNED' = 'RETURNED',
  'SHIPMENT_WAITING' = 'SHIPMENT_WAITING',
  'SHIPPING' = 'SHIPPING',
  'SOURCING' = 'SOURCING',
}
export const CONST_PURCHASE_ORDER_BUYER_STATUS = Object.values(PURCHASE_ORDER_BUYER_STATUS);

export enum PURCHASE_ORDER_PARTIAL_REFUND_STATUS {
  'PARTIAL_REFUND_CANCELLED' = 'PARTIAL_REFUND_CANCELLED',
  'PARTIAL_REFUND_REQUEST' = 'PARTIAL_REFUND_REQUEST',
  'PARTIAL_REFUND_WAITING' = 'PARTIAL_REFUND_WAITING',
  'PARTIAL_REFUNDED' = 'PARTIAL_REFUNDED',
}

export const CONST_PURCHASE_ORDER_PARTIAL_REFUND_STATUS = Object.values(PURCHASE_ORDER_PARTIAL_REFUND_STATUS);

export enum PURCHASE_ORDER_PRODUCT_STATUS {
  'CANCELLED' = 'CANCELLED',
  'DELIVERED' = 'DELIVERED',
  'EXCHANGED' = 'EXCHANGED',
  'PARTIAL_REFUND_WAITING' = 'PARTIAL_REFUND_WAITING',
  'PARTIAL_REFUNDED' = 'PARTIAL_REFUNDED',
  'PARTIAL_SOURCING' = 'PARTIAL_SOURCING',
  'PENDING' = 'PENDING',
  'REFUND_WAITING' = 'REFUND_WAITING',
  'REFUNDED' = 'REFUNDED',
  'RETURNED' = 'RETURNED',
  'SHIPMENT_WAITING' = 'SHIPMENT_WAITING',
  'SHIPPING' = 'SHIPPING',
  'SOURCING' = 'SOURCING',
  'SOURCING_IMPOSSIBLE' = 'SOURCING_IMPOSSIBLE',
}
export const CONST_PURCHASE_ORDER_PRODUCT_STATUS = Object.values(PURCHASE_ORDER_PRODUCT_STATUS);

export enum REFUND_METHOD {
  'CREDIT' = 'CREDIT',
  // 'EXIMBAY' = 'CREDIT/DEBIT',
  'PAYPAL' = 'PAYPAL',
  'PAYONEER' = 'PAYONEER',
  'TT' = 'TT',
}
export const CONST_REFUND_METHOD = Object.values(REFUND_METHOD);

export enum REFUND_TYPE {
  'REFUND' = 'REFUND',
  'REFUSE' = 'REFUSE',
}
export const CONST_REFUND_TYPE = Object.values(REFUND_TYPE);

export enum REFUSE_TYPE {
  'ADDRESS' = 'ADDRESS',
  'CEO_NAME' = 'CEO_NAME',
  'COMPANY_NAME' = 'COMPANY_NAME',
  'ETC' = 'ETC',
  'TELEPHONE' = 'TELEPHONE',
  'BUSINESS_URL' = 'BUSINESS_URL',
}
export const CONST_REFUSE_TYPE = Object.values(REFUSE_TYPE);

export enum SHIPPING_LABEL_OPTION {
  'BOTH_NAME' = 'BOTH_NAME',
  'COMPANY_NAME' = 'COMPANY_NAME',
  'RECIPIENT_NAME' = 'RECIPIENT_NAME',
}
export const CONST_SHIPPING_LABEL_OPTION = Object.values(SHIPPING_LABEL_OPTION);

export enum SIGNIN_LOG_TYPE {
  'REFRESH_TOKEN' = 'REFRESH_TOKEN',
  'SIGNIN' = 'SIGNIN',
  'TOKEN' = 'TOKEN',
  'WRONG_PASSWORD' = 'WRONG_PASSWORD',
}
export const CONST_SIGNIN_LOG_TYPE = Object.values(SIGNIN_LOG_TYPE);

export enum TRANSACTION_TYPE {
  'CREDIT_IN' = 'CREDIT_IN',
  'CREDIT_OUT' = 'CREDIT_OUT',
  'POINT_EXPIRED' = 'POINT_EXPIRED',
  'POINT_IN' = 'POINT_IN',
  'POINT_OUT' = 'POINT_OUT',
  'PURCHASE_CANCEL' = 'PURCHASE_CANCEL',
  'PURCHASE_ORDER' = 'PURCHASE_ORDER',
}
export const CONST_TRANSACTION_TYPE = Object.values(TRANSACTION_TYPE);

export enum WEIGHT_TYPE {
  'ABSOLUTE' = 'ABSOLUTE',
  'MULTIPLE' = 'MULTIPLE',
}
export const CONST_WEIGHT_TYPE = Object.values(WEIGHT_TYPE);

export enum WITHDRAW_REFUND_STATUS {
  'COMPLETED' = 'COMPLETED',
  'CONFIRM' = 'CONFIRM',
  'REFUND_RE_WAITING' = 'REFUND_RE_WAITING',
  'REFUND_WAITING' = 'REFUND_WAITING',
  'REFUNDED' = 'REFUNDED',
}

export const CONST_WITHDRAW_REFUND_STATUS = Object.values(WITHDRAW_REFUND_STATUS);

export enum WITHDRAW_TYPE {
  'PERSONAL' = 'PERSONAL',
  'SERVICE' = 'SERVICE',
  'SITE' = 'SITE',
}
export const CONST_WITHDRAW_TYPE = Object.values(WITHDRAW_TYPE);

export enum TRANSACTION_SUBTYPE__CREDIT_IN {
  'CREDIT_IN_ETC' = 'CREDIT_IN_ETC',
}
export enum TRANSACTION_SUBTYPE__CREDIT_OUT {
  'CREDIT_OUT_ETC' = 'CREDIT_OUT_ETC',
}
export enum TRANSACTION_SUBTYPE__POINT_EXPIRED {
  'POINT_EXPIRED_PERIOD' = 'POINT_EXPIRED_PERIOD',
}
export enum TRANSACTION_SUBTYPE__POINT_IN {
  'POINT_IN_ETC' = 'POINT_IN_ETC',
  'POINT_IN_ORDER' = 'POINT_IN_ORDER',
  'POINT_IN_ORDER_LEVEL' = 'POINT_IN_ORDER_LEVEL',
  'PROMOTION_FIRST_ORDER' = 'PROMOTION_FIRST_ORDER',
  'PROMOTION_WELCOME' = 'PROMOTION_WELCOME',
}
export enum TRANSACTION_SUBTYPE__POINT_OUT {
  'POINT_OUT_ETC' = 'POINT_OUT_ETC',
  'WITHDRAW_MEMBER' = 'WITHDRAW_MEMBER',
}
export enum TRANSACTION_SUBTYPE__PURCHASE_CANCEL {
  'CANCEL' = 'CANCEL',
  'PARTIAL_REFUND' = 'PARTIAL_REFUND',
  'REFUND' = 'REFUND',
  'RETURN' = 'RETURN',
}
export enum TRANSACTION_SUBTYPE__PURCHASE_ORDER {
  'PAYMENT' = 'PAYMENT',
  'PENDING' = 'PENDING',
  'PURCHASE_ORDER' = 'PURCHASE_ORDER',
}
export const TRANSACTION_SUBTYPE = {
  CREDIT_IN: TRANSACTION_SUBTYPE__CREDIT_IN,
  CREDIT_OUT: TRANSACTION_SUBTYPE__CREDIT_OUT,
  POINT_EXPIRED: TRANSACTION_SUBTYPE__POINT_EXPIRED,
  POINT_IN: TRANSACTION_SUBTYPE__POINT_IN,
  POINT_OUT: TRANSACTION_SUBTYPE__POINT_OUT,
  PURCHASE_CANCEL: TRANSACTION_SUBTYPE__PURCHASE_CANCEL,
  PURCHASE_ORDER: TRANSACTION_SUBTYPE__PURCHASE_ORDER,
};
export type TRANSACTION_SUBTYPE =
  | TRANSACTION_SUBTYPE__CREDIT_IN
  | TRANSACTION_SUBTYPE__CREDIT_OUT
  | TRANSACTION_SUBTYPE__POINT_EXPIRED
  | TRANSACTION_SUBTYPE__POINT_IN
  | TRANSACTION_SUBTYPE__POINT_OUT
  | TRANSACTION_SUBTYPE__PURCHASE_CANCEL
  | TRANSACTION_SUBTYPE__PURCHASE_ORDER;
export const CONST_TRANSACTION_SUBTYPE = Object.values(TRANSACTION_SUBTYPE);

export enum WITHDRAW_SUBTYPE__PERSONAL {
  'EXPOSURE' = 'EXPOSURE',
  'REAPPLY' = 'REAPPLY',
}
export enum WITHDRAW_SUBTYPE__SERVICE {
  'CUSTOMER_SERVICE' = 'CUSTOMER_SERVICE',
  'LATE_DELIVERY' = 'LATE_DELIVERY',
  'OTHER_B2B_SERVICE' = 'OTHER_B2B_SERVICE',
  'REFUND_EXCHANGE' = 'REFUND_EXCHANGE',
}
export enum WITHDRAW_SUBTYPE__SITE {
  'BUYER_BENEFIT' = 'BUYER_BENEFIT',
  'LOW_USAGE' = 'LOW_USAGE',
  'PRODUCT_PRICE' = 'PRODUCT_PRICE',
}
export const WITHDRAW_SUBTYPE = {
  PERSONAL: WITHDRAW_SUBTYPE__PERSONAL,
  SERVICE: WITHDRAW_SUBTYPE__SERVICE,
  SITE: WITHDRAW_SUBTYPE__SITE,
};
export type WITHDRAW_SUBTYPE = WITHDRAW_SUBTYPE__PERSONAL | WITHDRAW_SUBTYPE__SERVICE | WITHDRAW_SUBTYPE__SITE;
export const CONST_WITHDRAW_SUBTYPE = Object.values(WITHDRAW_SUBTYPE);

export enum USED_TYPE {
  'USED' = 'USED',
  'ADDED' = 'ADDED',
  'REMOVED' = 'REMOVED',
}
export const CONST_USED_TYPE = Object.values(USED_TYPE);

export enum LANGUAGE_TYPE {
  'EN' = 'en',
  'VI' = 'vi',
}

export const CONST_LANUGAGE_TYPE = Object.values(LANGUAGE_TYPE);

export enum REVIEW_LANGUAGE_TYPE {
  'EN' = 'en',
  'VI' = 'vi',
  'RU' = 'ru',
  'DE' = 'de',
  'FR' = 'fr',
  'PT' = 'pt',
  'ES' = 'es',
  'IT' = 'it',
  'AR' = 'ar',
  'NL' = 'nl',
  'SV' = 'sv',
  'JA' = 'ja',
}

export const CONST_REVIEW_LANGUAGE_TYPE = Object.values(REVIEW_LANGUAGE_TYPE);

export enum DISCOUNT_TYPE {
  'FIXED' = 'FIXED',
  'PERCENT' = 'PERCENT',
}
export const CONST_DISCOUNT_TYPE = Object.values(DISCOUNT_TYPE);

export enum COUPON_STATUS {
  'DELETED' = 'DELETED',
  'USABLE' = 'USABLE',
  'USED' = 'USED',
}
export const CONST_COUPON_STATUS = Object.values(COUPON_STATUS);

export enum COUPON_PUBLISH_TYPE {
  'BUYER' = 'BUYER',
  'DORMANT' = 'DORMANT',
  'SIGNUP' = 'SIGNUP',
  'SYSTEM' = 'SYSTEM',
  'APP' = 'APP',
}
export const CONST_COUPON_PUBLISH_TYPE = Object.values(COUPON_PUBLISH_TYPE);

export enum COUPON_USABLE_TYPE {
  'ALL' = 'ALL',
  'BRAND' = 'BRAND',
  'CATEGORY' = 'CATEGORY',
  'DOWNLOAD' = 'DOWNLOAD',
  'EUROPEDIRECT' = 'EUROPEDIRECT',
  'PRODUCT' = 'PRODUCT',
  'SHIPPING' = 'SHIPPING',
  'UQUICK' = 'UQUICK',
}
export const CONST_COUPON_USABLE_TYPE = Object.values(COUPON_USABLE_TYPE);

export enum USING_EXPIRE_TYPE {
  'DURATION' = 'DURATION',
  'TIMESTAMP' = 'TIMESTAMP',
}
export const CONST_USING_EXPIRE_TYPE = Object.values(USING_EXPIRE_TYPE);

// Campaign

export enum OBTAIN_RULE_TYPE {
  'PURCHASE_PRICE' = 'PURCHASE_PRICE',
}
export const CONST_OBTAIN_RULE_TYPE = Object.values(OBTAIN_RULE_TYPE);

export enum CAMPAIGN_TYPE {
  'SAMPLE_PRODUCT' = 'SAMPLE_PRODUCT',
}
export const CONST_CAMPAIGN_TYPE = Object.values(CAMPAIGN_TYPE);

export enum CAMPAIGN_USABLE_TYPE {
  'ALL' = 'ALL',
  'BRAND' = 'BRAND',
  'COUNTRY' = 'COUNTRY',
  'EUROPEDIRECT' = 'EUROPEDIRECT',
  'PRODUCT' = 'PRODUCT',
}
export const CONST_CAMPAIGN_USABLE_TYPE = Object.values(CAMPAIGN_USABLE_TYPE);

export enum UMMA_LANGUAGE {
  EN = 'en',
  VI = 'vi',
}
